import React from 'react'
import styles from './PaymentSuccess.scss'
import {CTA} from 'common/styleguide/CTA'

export class PaymentSuccess extends React.PureComponent {
  render () {
    return (
      <div className={styles.PaymentSuccess}>
        <div className={styles.withPadding}>
          <h2>Thank You!</h2>
        </div>
        <div className={styles.line} />
        <div className={styles.next}>
        Thank you! We appreciate your support and can’t wait to see where you are riding!
        </div>
        <div className={styles.toProfile}>
          <CTA href={`/`}>Go to Profile</CTA>
        </div>
      </div>
    )
  }
}
